import { DashboardSearchData, DashboardSearchModel } from './types-store';

export const ACTION = {
  CLEAR_LIST: 'DASHBOARD_ADMINISTRATION:CLEAR_LIST',

  REQUEST_LIST: 'DASHBOARD_ADMINISTRATION:REQUEST_LIST',
  RECEIVE_LIST: 'DASHBOARD_ADMINISTRATION:RECEIVE_LIST',
  FAIL_LIST: 'DASHBOARD_ADMINISTRATION:FAIL_LIST',

  REQUEST_DELETE_DASHBOARD: 'DASHBOARD_ADMINISTRATION:REQUEST_DELETE_DASHBOARD',
  RECEIVE_DELETE_DASHBOARD: 'DASHBOARD_ADMINISTRATION:RECEIVE_DELETE_DASHBOARD',
  FAIL_DELETE_DASHBOARD: 'DASHBOARD_ADMINISTRATION:FAIL_DELETE_DASHBOARD'
};

export class ClearList {
  public type: string = ACTION.CLEAR_LIST;
  constructor(public requestId: number) { }
}

export class RequestList {
  public type: string = ACTION.REQUEST_LIST;
  constructor(public requestId: number, public model: DashboardSearchModel, public clearResults: boolean) { }
}

export class ReceiveList {
  public type: string = ACTION.RECEIVE_LIST;
  constructor(public requestId: number, public list: DashboardSearchData[], public numberOfResults: number) { }
}

export class FailList {
  public type: string = ACTION.FAIL_LIST;
  constructor(public requestId: number) { }
}

export class RequestDeleteDashboard {
  public type: string = ACTION.REQUEST_DELETE_DASHBOARD;
  constructor(public id: number) { }
}

export class ReceiveDeleteDashboard {
  public type: string = ACTION.RECEIVE_DELETE_DASHBOARD;
  constructor(public id: number) { }
}

export class FailDeleteDashboard {
  public type: string = ACTION.FAIL_DELETE_DASHBOARD;
  constructor(public id: number) { }
}
